export const SIZE_STUB = { width: 300, height: 80 };

// media widgets measure their own size from content, but there's
// still a limit to how large they are made initially
export const MAX_INITIAL_SIZE_MEDIA = { width: 800, height: 800 };
export const MIN_SIZE_MEDIA = { width: 80, height: 54 };
export const MAX_SIZE_MEDIA = { width: 4000, height: 4000 };

export const INITIAL_SIZE_FRAME_MEDIA = { width: 340, height: 94 };
export const MIN_SIZE_FRAME_MEDIA = { width: 320, height: 480 };
export const MAX_SIZE_FRAME_MEDIA = { width: 4000, height: 4000 };

export const SIZE_AUDIO_MEDIA = { width: 320, height: 94 };
